<template>
  <div class="custom-modal-wrap overflow-y-auto  overflow-x-hidden fixed top-0 right-0 left-0 z-[100] md:inset-0 h-modal md:h-full justify-center items-center flex">
    <div class="relative  pt-[80px] pb-[80px]  grid items-center p-4 w-full h-full md:h-[100vh] max-w-[820px]">
        <div class="relative rounded-xl shadow bg-theme-modalbg">
      <div class="grid grid-cols-1 lg:grid-cols-1 gap-3" style="font-family: Arial">
        <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
          <div class="w-[800px] rounded-2xl shadow-[0px_25px_50px_-12px_rgba(0,0,0,1.00)] inline-flex flex-col justify-start items-center overflow-hidden">
            <div class="self-stretch px-6 py-4 bg-green-500 inline-flex justify-start items-start gap-6">
              <div class="flex-1 self-stretch inline-flex flex-col justify-center items-center gap-0.5">
                <div class="self-stretch justify-center text-white text-xl font-bold font-['Roboto'] leading-6 tracking-tight line-clamp-1">Edit Business Profile</div>
                <div class="self-stretch justify-center text-white text-sm font-normal font-['Roboto'] leading-4 line-clamp-1">Set branding that will apply to all locations assigned to this business profile.</div>
              </div>
              <div class="flex justify-end items-center gap-4">
                <button @click="closePop" data-configuration="Text-L" data-fill="True" data-show-icon="False" data-state="Default" class="w-24 h-11 p-4 rounded outline outline-1 outline-offset-[-1px] outline-white flex justify-center items-center gap-2">
                  <div class="text-center justify-center text-white text-sm font-medium font-['Roboto'] uppercase leading-4 tracking-widest">CANCEL</div>
                </button>
                <button @click="updateBusinessProfile" data-configuration="Text-L" data-fill="True" data-show-icon="False" data-state="Default" class="w-24 h-11 p-4 bg-white rounded flex justify-center items-center gap-2">
                  <div class="text-center justify-center text-green-500 text-sm font-medium font-['Roboto'] uppercase leading-4 tracking-widest">Update</div>
                </button>
              </div>
            </div>
            <div class="self-stretch px-6 pt-6 bg-zinc-800 flex flex-col justify-start items-start gap-6 h-[600px] overflow-y-auto">
              <div class="self-stretch flex flex-col justify-start items-start gap-4" :class="'input-wrapper ' + (businessForm.name.error_type)">
                <div class="self-stretch justify-center text-white text-base font-bold font-['Roboto'] leading-5 tracking-tight">Branding</div>
                <div :class="'self-stretch flex flex-col justify-start items-start gap-1 ' + (businessForm.name.error_type)">
                  <label for="business" class="self-stretch justify-start text-white text-xs font-normal font-['Roboto'] leading-4">Business Name *</label>
                  <input id="business" @keyup="validateFields(['name'])" v-model="businessForm.name.value" class="self-stretch h-10 px-2 py-2.5 bg-zinc-700 rounded-md text-white text-base font-normal font-['Roboto'] leading-5  border-2 focus:border-transparent outline-0 ring-0 focus:outline-0 focus:ring-0" placeholder="Business Name" type="text" />
                  <p class="field-error text-red-500 text-xs mt-1" v-if="businessForm.name.error_message" v-text="businessForm.name.error_message"></p>
                </div>
                <div class="self-stretch inline-flex justify-start items-start gap-4">
                  <div class="flex-1 inline-flex flex-col justify-start items-start gap-1">
                    <div class="self-stretch justify-start text-white text-xs font-normal font-['Roboto'] leading-4">Primary Color *</div>
                    <div class="self-stretch h-10 px-2 py-2.5 bg-zinc-700 rounded-md inline-flex justify-start items-center gap-2">
                      <input type="color" v-model="form.primaryColor" class="invisible w-0" id="primary_color">
                      <label class="cursor-pointer flex items-center w-full" for="primary_color">
                        <div class="w-4 h-4 rounded-sm mr-2" :style="'background:' + (form.primaryColor || '#FFFFFF')"></div>
                        <div class="flex-1 text-white text-base font-normal font-['Roboto'] leading-5">
                          {{ form.primaryColor || '#FFFFFF' }}
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="flex-1 inline-flex flex-col justify-start items-start gap-1">
                    <div class="self-stretch justify-start text-white text-xs font-normal font-['Roboto'] leading-4">Secondary Color *</div>
                    <div class="self-stretch h-10 px-2 py-2.5 bg-zinc-700 rounded-md inline-flex justify-start items-center gap-2">
                      <input type="color" v-model="form.secondaryColor" class="invisible w-0" id="secondary_color">
                      <label class="cursor-pointer flex items-center w-full" for="secondary_color">
                        <div class="w-4 h-4 rounded-sm mr-2" :style="'background:' + (form.secondaryColor || '#FFFFFF')"></div>
                        <div class="flex-1 text-white text-base font-normal font-['Roboto'] leading-5">
                          {{ form.secondaryColor || '#FFFFFF' }}
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="self-stretch flex flex-col justify-start items-start gap-4">
                  <div class="self-stretch inline-flex justify-start items-start gap-4">
                    <div class="flex-1 justify-start text-white text-xs font-normal font-['Roboto'] leading-4">Business Logo *</div>
                    <div class="flex-1 justify-start text-white text-xs font-normal font-['Roboto'] leading-4">Browser Favicon (optional)</div>
                  </div>
                  <div class="self-stretch inline-flex justify-start items-start gap-4">
                    <div class="flex-1 inline-flex flex-col justify-start items-start gap-1">
                      <file-manager v-model="form.logo" :validFileTypes="['image']" :class="'flex cursor-pointer flex-col items-center justify-between rounded-md ' + (form.logo ? ' border-zinc-700 border outline outline-1 outline-offset-[-1px]' : 'border-2  border-green-500 px-4 py-[21px] border-dashed' )" label="SELECT">
                        <template v-slot:custom="{ onClick }">
                          <div class="relative w-full flex flex-row justify-between">
                            <button v-if="form.logo" class="absolute hover:opacity-80 z-10 top-2 right-2 bg-red-700 text-[#fff] rounded-full h-[30px] w-[30px] flex justify-center items-center" @click="form.logo = undefined">×</button>

                            <div v-if="form.logo" class="w-full h-[201px] flex items-center justify-center relative z-1">
                              <img class="w-auto h-full" :src="form.logo" />
                            </div>
                            <div v-else @click="onClick" class="w-full">
                              <div class="w-full h-[115px] flex items-center justify-center ">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M19.3334 11.3332H11.3334V19.3332H8.66675V11.3332H0.666748V8.6665H8.66675V0.666504H11.3334V8.6665H19.3334V11.3332Z" fill="#2BA66B" />
                                </svg>
                              </div>
                              <p class="text-[#9E9E9E] text-center text-sm px-[12px]">Please upload a high-quality image of your business logo in JPEG or PNG format</p>
                            </div>
                          </div>
                        </template>
                      </file-manager>
                    </div>
                    <div class="flex-1 inline-flex flex-col justify-start items-start gap-1">
                      <file-manager v-model="form.favicon" :validFileTypes="['image']" :class="'flex cursor-pointer flex-col items-center justify-between rounded-md ' + (form.favicon ? ' border-zinc-700 border outline outline-1 outline-offset-[-1px]' : 'border-2  border-green-500 px-4 py-[21px] border-dashed' )" label="SELECT">
                        <template v-slot:custom="{ onClick }">
                          <div class="relative w-full flex flex-row justify-between">
                            <button v-if="form.favicon" class="absolute hover:opacity-80 z-10 top-2 right-2 bg-red-700 text-[#fff] rounded-full h-[30px] w-[30px] flex justify-center items-center" @click="form.favicon = undefined">×</button>

                            <div v-if="form.favicon" class="w-full h-[201px] flex items-center justify-center relative z-1">
                              <img class="w-auto h-full" :src="form.favicon" />
                            </div>
                            <div v-else @click="onClick" class="w-full">
                              <div class="w-full h-[115px] flex items-center justify-center ">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M19.3334 11.3332H11.3334V19.3332H8.66675V11.3332H0.666748V8.6665H8.66675V0.666504H11.3334V8.6665H19.3334V11.3332Z" fill="#2BA66B" />
                                </svg>
                              </div>
                              <p class="text-[#9E9E9E] text-center text-sm px-[12px]">Please upload a square image in JPEG or PNG format for the best fit.</p>
                            </div>
                          </div>
                        </template>
                      </file-manager>
                    </div>
                  </div>
                </div>
                <div class="self-stretch w-full px-0 py-0">
                  <label class="flex items-center cursor-pointer">
                    <span class="font-bold text-base leading-5 tracking-[0.15px] h-[20px] mr-5 text-white">Cash Rounding</span>
                    <input type="checkbox" v-model="form.cashRounding" class="hidden peer">
                    <div :class="'relative toggle-bg border-2 h-6 w-11 rounded-full ' + (form.cashRounding ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                  </label>
                  <p class="font-normal text-sm leading-[17.5px] my-3 text-neutral-300">With cash rounding enabled, your cash payments will be rounded to the nearest .05.</p>
                </div>
              </div>
              <div class="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-zinc-700"></div>
              <div class="self-stretch flex flex-col justify-start items-start gap-4">
                <div class="self-stretch justify-center text-white text-base font-bold font-['Roboto'] leading-5 tracking-tight">Website & Domain Settings</div>
                <div class="self-stretch inline-flex justify-start items-start gap-4">
                  <div class="flex-1 inline-flex flex-col justify-start items-start gap-1">
                    <div class="self-stretch justify-start text-white text-xs font-normal font-['Roboto'] leading-4">Merchant Website URL (optional)</div>
                    <input v-model="websiteForm.domain.value" class="self-stretch h-10 px-2 py-2.5 bg-zinc-700 rounded-md text-white text-base font-normal font-['Roboto'] leading-5 border-0 focus:outline-none focus:ring-0" placeholder="https://example.com" type="text" />
                  </div>
                  <div class="flex-1 inline-flex flex-col justify-start items-start gap-1">
                    <div class="self-stretch justify-start text-white text-xs font-normal font-['Roboto'] leading-4">Google Analytics Tracking ID (optional)</div>
                    <input v-model="websiteForm.googleAnalyticsKey.value" class="self-stretch h-10 px-2 py-2.5 bg-zinc-700 rounded-md text-white text-base font-normal font-['Roboto'] leading-5 border-0 focus:outline-none focus:ring-0" placeholder="UA-XXXXXXXXX-X" type="text" />
                  </div>
                </div>
                <!-- <div class="w-[752px] flex flex-col justify-start items-start gap-1">
                  <div class="self-stretch justify-start text-white text-xs font-normal font-['Roboto'] leading-4">DNS Record</div>
                  <div class="self-stretch px-2 py-2.5 rounded-md outline outline-1 outline-offset-[-1px] outline-zinc-700 flex flex-col justify-start items-start gap-2.5">
                    <div class="self-stretch justify-start text-neutral-400 text-xs font-normal font-['Roboto'] leading-4">Add this DNS record to your domain provider to connect your custom domain. This will redirect your Shop pages to your website.</div>
                    <div class="self-stretch inline-flex justify-start items-center gap-2">
                      <div class="justify-start text-neutral-400 text-base font-normal font-['Roboto'] leading-5 line-clamp-1">Link:</div>
                      <div class="flex-1 justify-start text-white text-base font-normal font-['Roboto'] underline leading-6 line-clamp-1">text link (clickable) - it opens a page</div>
                    </div>
                    <div class="self-stretch inline-flex justify-start items-center gap-2">
                      <div class="justify-start text-neutral-400 text-base font-normal font-['Roboto'] leading-5 line-clamp-1">Type:</div>
                      <div class="flex-1 justify-start text-white text-base font-normal font-['Roboto'] leading-5 line-clamp-1">CNAME</div>
                    </div>
                    <div class="self-stretch inline-flex justify-start items-center gap-2">
                      <div class="justify-start text-neutral-400 text-base font-normal font-['Roboto'] leading-5 line-clamp-1">Value:</div>
                      <div class="flex-1 justify-start text-white text-base font-normal font-['Roboto'] leading-5 line-clamp-1">
                        {{ businessName || 'bargainbuds.com' }}
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script lang="ts">
  import {
    defineComponent,
    ref,
    watch
  } from "vue"
  import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";
  import Helpers from '@/helpers';
  import {
    useSnackbar
  } from "vue3-snackbar";
  import BrandingProfileApis from '@/controllers/BrandingProfileApis';
  import FileManager from '@/components/manager/filemanager.vue'
  import DragUpload from '@/views/Settings/DragUpload.vue';

  export default defineComponent({
    name: "EditProfile",
    components: {
      FileManager,
      DragUpload
    },
    props: {
      branding: {
        type: Object as() => Record < string,
        any > | null,
        default: null
      },
      businessName: {
        type: String,
        default: ''
      },
      merchantWebsiteUrl: {
        type: String,
        default: ''
      },
      googleAnalyticsTrackingId: {
        type: String,
        default: ''
      }
    },
    setup() {
      const snackbar = useSnackbar();
      const businessForm = ref({
        name: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'min:3'],
        },
      });
      const form = ref<{
        primaryColor: string
        secondaryColor: string
        logo?: string
        favicon?: string
        cashRounding: boolean
      }>({
        primaryColor: '',
        secondaryColor: '',
        logo: undefined,
        favicon: undefined,
        cashRounding: true,
      });
      const websiteForm = ref({
        domain: {
          value: '',
        },
        googleAnalyticsKey: {
          value: '',
        }
      });

      return {
        businessForm,
        form,
        websiteForm,
        snackbar
      };
    },
    computed: {
      ...mapGetters({
        va_activeBusiness: 'auth/activeBusiness',
      }),
    },
    watch: {
      branding: {
        handler(newVal) {
          if (newVal) {
            console.log(newVal?.cashRounding?.cashRounding)
            this.form.primaryColor = newVal.primaryColor || '#FFFFFF';
            this.form.secondaryColor = newVal.secondaryColor || '#FFFFFF';
            this.form.logo = newVal.logo || undefined;
            this.form.favicon = newVal.favicon || undefined;
            this.form.cashRounding = newVal?.cashRounding?.cashRounding;
          }
        },
        immediate: true
      },
      businessName: {
        handler(newVal) {
          if (newVal) {
            this.businessForm.name.value = newVal;
          }
        },
        immediate: true
      },
      merchantWebsiteUrl: {
        handler(newVal) {
          if (newVal !== undefined) {
            this.websiteForm.domain.value = newVal || '';
          }
        },
        immediate: true
      },
      googleAnalyticsTrackingId: {
        handler(newVal) {
          if (newVal !== undefined) {
            this.websiteForm.googleAnalyticsKey.value = newVal || '';
          }
        },
        immediate: true
      }
    },
    methods: {
      /**
       * Validation captures
       */
      async validateFields(fields) {
        let res = await Helpers.validateFormFields(this.businessForm, fields);
        // capture the fields
        this.businessForm = res.data;
        return res.error ? false : true;
      },

      /**
       * Update business profile
       */
      async updateBusinessProfile() {
        // validate business field
        let validate = await this.validateFields(['name']);
        if (!validate) {
          return;
        }
        if(!this.form.logo){
          this.snackbar.add({
            type: 'error',
            text: 'Business logo is required',
            duration: 3000,
          });
          return;
        }
        this.va_spinner(true);

        const brandingProfileData = {
          name: this.businessForm.name.value.trim(),
          domain: this.websiteForm.domain.value.trim() || null,
          googleAnalyticsKey: this.websiteForm.googleAnalyticsKey.value.trim() || null,
          logo: this.form.logo || null,
          favicon: this.form.favicon || null,
          primaryColor: this.form.primaryColor || '#3DBB9E',
          secondaryColor: this.form.secondaryColor || '#FFFFFF',
          cashRounding: this.form.cashRounding,
        };

        const profileId = this.branding?.id || this.va_activeBusiness?.id;
        const brandingRes = await BrandingProfileApis.updateBusinessBrandingProfile(profileId, brandingProfileData);

        if (brandingRes.status !== 200) {
          this.va_spinner(false);
          this.snackbar.add({
            type: 'error',
            text: Helpers.catchErrorMessage(brandingRes.response?.data) || 'Failed to update branding profile',
            duration: 3000,
          });
          return;
        }

        this.snackbar.add({
          type: 'info',
          text: 'Business profile updated successfully',
          duration: 3000,
        });
        this.closePop();
        this.$emit('updated');

        this.va_spinner(false);
      },

      closePop() {
        this.$emit('close')
      },

      ...mapMutations({
        vm_mutateUserActiveBusiness: "auth/mutateActiveBusiness",
      }),

      ...mapActions({
        va_spinner: 'spinner/setSpinner',
      })
    }
  })
</script>